// libraries
import React from 'react';
import styled from 'styled-components';

// styled components
import { CentredFlex, PrimaryButton, ColumnedFlex } from 'shared/styledComponents';
import { Title, H4 } from 'shared/typography';

const Wrapper = styled(CentredFlex)`
  width: 100%;
  height: 100%;
  justify-content: flex-start;
`;

const ContentWrapper = styled(ColumnedFlex)`
  align-items: center;
`;

const Heading = styled(H4)`
  margin-bottom: 20px;
  font-family: ${({ theme: { fonts } }): string => fonts.wigrumRegular};
  font-size: 24px;
  color: ${({ theme: { colors } }): string => colors.white};
`;

const StyledTitle = styled(Title)`
  margin-bottom: 20px;
  text-align: center;
  color: ${({ theme: { colors } }): string => colors.white};
`;

const CloseButton = styled(PrimaryButton)<any>`
  background-color: ${({ theme: { colors } }): string => colors.greenGable};
  color: ${({ theme: { colors } }): string => colors.white};
  padding: 10px 25px;
`;

interface ProviderSignUpSuccessProps {
  onClose: VoidFunction;
}

const ProviderSignUpSuccess = ({ onClose }: ProviderSignUpSuccessProps): JSX.Element => (
  <Wrapper>
    <ContentWrapper>
      <Heading>You have been successfully signed up</Heading>
      <StyledTitle>
        Thank you for applying to list your practice! Please check your email for additional communication.
      </StyledTitle>

      <CloseButton size="small" onClick={onClose}>
        ok
      </CloseButton>
      <img
        height="1"
        width="1"
        style={{ display: 'none' }}
        alt=""
        src="https://px.ads.linkedin.com/collect/?pid=2253026&conversionId=2691698&fmt=gif"
      />
    </ContentWrapper>
  </Wrapper>
);

export default ProviderSignUpSuccess;
